// Hamburger menu
let hamburger = document.querySelector('.hamburger');
let menu = document.querySelector('.list__btn');

function showMenu () {
  hamburger.classList.toggle('hamburger__active');
  menu.classList.toggle('list__btn--active');
}

// Copyright
let dateCopy = new Date();
document.querySelector('.footer__copyright p span').textContent = dateCopy.getFullYear();

// WOW Animation
let wow = new WOW(
    {
      boxClass:     'wow',
      animateClass: 'animate__animated',
      mobile: false
    }
);
wow.init();

// Video youtube
function r(f) {
  /in/.test(document.readyState) ? setTimeout(() => r(f), 9) : f();
}

r(function () {
  var videos;

  if (!document.getElementsByClassName) {
    // IE8 fallback
    var getElementsByClassName = function (node, classname) {
      var a = [];
      var re = new RegExp('(^| )' + classname + '( |$)');
      var els = node.getElementsByTagName("*");
      for (var i = 0; i < els.length; i++) {
        if (re.test(els[i].className)) a.push(els[i]);
      }
      return a;
    };
    videos = getElementsByClassName(document.body, "youtube");
  } else {
    videos = document.getElementsByClassName("youtube");
  }

  for (var i = 0; i < videos.length; i++) {
    var video = videos[i];

    // Постер YouTube
    video.style.backgroundImage =
        'url(https://img.youtube.com/vi/' + video.id + '/maxresdefault.jpg)';

    // 👉 Создаём кнопку Play для КАЖДОГО видео
    var play = document.createElement('div');
    play.className = 'about_brand__video--play';
    video.appendChild(play);

    video.onclick = function () {
      document.querySelectorAll('iframe.youtube').forEach((player) => {
        player.src = player.src.replace('autoplay=1', 'autoplay=0');
      });

      var iframe = document.createElement("iframe");
      var iframe_url =
          "https://www.youtube.com/embed/" +
          this.id +
          "?autoplay=1&autohide=1";

      if (this.getAttribute("data-params")) {
        iframe_url += '&' + this.getAttribute("data-params");
      }

      iframe.setAttribute("src", iframe_url);
      iframe.setAttribute("class", 'youtube');
      iframe.setAttribute("frameborder", '0');
      iframe.setAttribute("allowfullscreen", '');
      iframe.setAttribute(
          "allow",
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );

      this.parentNode.replaceChild(iframe, this);
    };
  }
});

// Modal Video
function prepareModalPlayers(modal) {
  if (!modal) return;

  // Сохраняем src у iframe один раз, чтобы потом подставлять/убирать
  const iframes = modal.querySelectorAll('iframe');
  iframes.forEach((iframe) => {
    if (!iframe.dataset.src) {
      const src = iframe.getAttribute('src');
      if (src) iframe.dataset.src = src;
    }
  });
}

function stopModalPlayers(modal) {
  if (!modal) return;

  // HTML5 <video>
  const videos = modal.querySelectorAll('video');
  videos.forEach((video) => {
    try {
      video.pause();
      video.currentTime = 0;
    } catch (_) {}
  });

  // YouTube/Vimeo <iframe> — убираем src, чтобы точно остановить и не перезапускать autoplay
  const iframes = modal.querySelectorAll('iframe');
  iframes.forEach((iframe) => {
    try {
      if (!iframe.dataset.src) {
        const src = iframe.getAttribute('src');
        if (src) iframe.dataset.src = src;
      }
      iframe.setAttribute('src', ''); // стоп
    } catch (_) {}
  });
}

function startModalPlayers(modal) {
  if (!modal) return;

  // Восстанавливаем src у iframe при открытии
  const iframes = modal.querySelectorAll('iframe');
  iframes.forEach((iframe) => {
    const saved = iframe.dataset.src;
    if (saved && iframe.getAttribute('src') !== saved) {
      iframe.setAttribute('src', saved);
    }
  });

  // Если у тебя HTML5 video и ты хочешь автостарт при открытии — раскомментируй:
  // const videos = modal.querySelectorAll('video');
  // videos.forEach((video) => {
  //   try { video.play(); } catch (_) {}
  // });
}

function openModal(modal) {
  if (!modal) return;

  const baseClass = modal.classList[0];
  const activeClass = `${baseClass}__active`;

  modal.classList.add(activeClass);
  startModalPlayers(modal);
}

function closeModal(modal) {
  if (!modal) return;

  const baseClass = modal.classList[0];
  const activeClass = `${baseClass}__active`;

  stopModalPlayers(modal);
  modal.classList.remove(activeClass);
}

// --- init
let modalVideo = document.querySelector('.modal_video'),
    modalOpen = document.querySelector('.video-play-button'),
    modalClose = document.querySelector('.close'),
    modalCloseX = document.querySelector('.close_x'),
    modalCloseBack = document.querySelector('.close_back');

if (modalVideo) {
  prepareModalPlayers(modalVideo);

  if (modalOpen) {
    modalOpen.addEventListener('click', () => openModal(modalVideo));
  }

  [modalClose, modalCloseX, modalCloseBack].forEach((btn) => {
    if (!btn) return;
    btn.addEventListener('click', () => closeModal(modalVideo));
  });
}
